import { UserTaskDetails } from '../types';
import { medtechApi } from './index';

const userTasksApi = {
  async getUserTaskDetails(company: number, taskId: number): Promise<UserTaskDetails | undefined> {
    const res = await medtechApi.get(`/v2/${company}/usertasks/${taskId}`);
    return UserTaskDetails.parse(res.data);
  },
};

export default userTasksApi;
